export const getMonerisCSS = () => {
    return '&css_textbox=width:174px;height:50.4px;border:2px solid rgb(156 163 175);border-width:1.5px;box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);margin-top:1.5px;margin-left: 11px;'
}
